import axios from 'axios';
import { ElMessageBox as MessageBox, ElMessage as Message } from 'element-plus';
import store from '@/store';
import { getToken } from '@/utils/auth';

// 根据环境变量选择正确的API基础路径
const apiBaseUrl = process.env.NODE_ENV === 'production' 
  ? '/truck-api'
  : process.env.VUE_APP_BASE_URL;

const service = axios.create({
  baseURL: apiBaseUrl,
  // 120s 超时
  timeout: 120e3
});

// 请求拦截
service.interceptors.request.use(
  (config) => {
    config.headers.token = getToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截
service.interceptors.response.use(
  (response) => {
    const { config, data } = response;
    if (response.status === 200 && config.headers.justBlob) {
      return data;
    }

    if (!data.message) {
      return Promise.reject(new Error('请求失败'));
    }

    const { code, status, message } = data.message;

    if (code === 201) {
      store.dispatch('user/logout').then(() => {
        location.reload();
      });
    }
    if (status !== 200) {
      Message({
        message: message || '请求失败',
        type: 'error',
        duration: 5 * 1000
      });

      // 50008-非法的令牌; 50012-其他已登录的客户端; 50014-过期令牌;
      if ([50008, 50012, 50014].includes(status)) {
        MessageBox.confirm('您已注销，您可以取消以留在此页面上，或重新登录', '确认注销', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload();
          });
        });
      }
      return Promise.reject(new Error(message));
    } else {
      return data;
    }
  },
  (error) => {
    // 网络错误静默处理，不在页面显示错误
    // 只有明确需要提示的错误才显示
    return Promise.reject(error);
  }
);
export default service;
